import React, { useState } from "preact/compat"
import { CalloutProps } from "./callout.type"

export const Callout = ({
    toggleVisibility = false,
    className,
    type,
    dismissible = false,
    children,
}: CalloutProps) => {
    const [remove, setRemove] = useState(false);

    const closeAlert = () => {
        setRemove(true);
    }
    return (
        <div>
            {toggleVisibility ? 
                <div className={`alert alert-${type} ${!remove ? 'd-flex' : 'd-none'} ${dismissible ? 'alert-dismissible': ''} ${className ?? ''}`} role="alert">
                    {dismissible ? 
                        <div className='w-75'>{children}</div>
                    : 
                        children 
                    }
                    {dismissible ? 
                        <button type="button" className="position-absolute top-0 end-0 btn btn-link p-0 mt-1 me-2" aria-label="Close" onClick={closeAlert}>
                            <img src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'><path d='M13 1L1 13M1 1L13 13' stroke='%2315202B' stroke-width='1.2'/></svg>" alt="close icon" role="img" width={14} height={14} />
                        </button>
                    : ''}
                </div>
            : ''}
        </div>
    )
}